import { render } from "./TransporterNav.vue?vue&type=template&id=70383dcc"
import script from "./TransporterNav.vue?vue&type=script&lang=js"
export * from "./TransporterNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__